import { ReactElement } from 'react';
/* eslint-disable max-len */
export const StreamlinesAdmin = ({ fill = 'none', stroke = 'currentColor' }: any): ReactElement => {
  return (
    <svg x="0px" y="0px" width={'24px'} height={'24px'} viewBox="0 0 36 36">
      <path
        {...{ stroke, fill }}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        d="M18,2.5c0.828,0,1.5,0.672,1.5,1.5s-0.672,1.5-1.5,1.5s-1.5-0.672-1.5-1.5S17.172,2.5,18,2.5z"
      />
      <path
        {...{ stroke, fill }}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        d="M18,29.5c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S18.828,29.5,18,29.5z"
      />
      <path
        {...{ stroke, fill }}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        d="M29.5,18c0,0.828-0.672,1.5-1.5,1.5s-1.5-0.672-1.5-1.5s0.672-1.5,1.5-1.5S29.5,17.172,29.5,18z"
      />
      <path
        {...{ stroke, fill }}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        d="M2.5,18c0-0.828,0.672-1.5,1.5-1.5s1.5,0.672,1.5,1.5s-0.672,1.5-1.5,1.5S2.5,18.828,2.5,18z"
      />
      <path
        {...{ stroke, fill }}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        d="M25.5,6.5c0.828,0,1.5,0.672,1.5,1.5s-0.672,1.5-1.5,1.5s-1.5-0.672-1.5-1.5S24.672,6.5,25.5,6.5z"
      />
      <path
        {...{ stroke, fill }}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        d="M10.5,25.5c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S11.328,25.5,10.5,25.5z"
      />
      <path
        {...{ stroke, fill }}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        d="M25.5,25.5c0.828,0,1.5,0.672,1.5,1.5s-0.672,1.5-1.5,1.5s-1.5-0.672-1.5-1.5S24.672,25.5,25.5,25.5z"
      />
      <path
        {...{ stroke, fill }}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        d="M10.5,6.5c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S11.328,6.5,10.5,6.5z"
      />
      <path
        {...{ stroke, fill }}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        d="M18,8.5c5.247,0,9.5,4.253,9.5,9.5s-4.253,9.5-9.5,9.5s-9.5-4.253-9.5-9.5S12.753,8.5,18,8.5z"
      />
    </svg>
  );
};
/* eslint-enable max-len */
